import { useSelector } from 'react-redux'
import { UserData } from 'models/Auth'
import { PATIENT_SAVED_PLAN } from 'settings/_storageFlagsSettings'

const getSavedPlanCode = (): string => {
  try {
    return localStorage.getItem(PATIENT_SAVED_PLAN)
  } catch (error) {
    console.error('Erro ao acessar localStorage:', error)
  }
}

export const useAllowsAutomaticSchedulingThroughReservation = (): boolean => {
  const profileSelected = useSelector((state: UserData) => state.auth.profileSelected)
  const savedPlanCode = getSavedPlanCode()

  const currentPlan = savedPlanCode
    ? profileSelected?.plans?.find((plan) => plan.partner_plan_code === savedPlanCode)
    : profileSelected?.plans?.find((plan) => plan.default === true)

  return currentPlan?.allows_automatic_scheduling_via_reservation ?? false
}

